import { runInAction } from 'mobx';
import React, { useEffect, useMemo, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { basedAxios as Axios, useStore } from '../../store/Store';

const EventLabel = observer(({ name, groupName, textOnly = false, languageCode = null, evId = null }) => {
  const store = useStore();
  const eventId = evId || store?.environment?.eventId;
  const lang = languageCode || store?.environment?.lang;

  groupName = groupName.toUpperCase();
  const label = useMemo(() => {
    return store.eventLabels?.[groupName]?.[name.toUpperCase()] || null;
  }, [store.eventLabels?.[groupName], groupName, name]);

  useEffect(() => {
    if (typeof store.eventLabels[groupName] !== 'object' && store.eventLabels[groupName] !== 'Loading') {
      getGroup();
    } else if (label && label.languageCode != lang) {
      getGroup();
    }
  }, [store.eventLabels[groupName], label, lang]);

  const getGroup = useCallback(() => {
    runInAction(() => {
      store.eventLabels[groupName] = 'Loading';
    });
    Axios.get(`./eventLabel/getGroup/${eventId}?groupName=${groupName}&languageCode=${lang}`).then(({ data }) => {
      runInAction(() => {
        const groups = { ...store.eventLabels };
        const groupData = {};
        data.map(d => {
          groupData[d.name.toUpperCase()] = d;
        });
        groups[groupName.toUpperCase()] = groupData;
        store.eventLabels = groups;
      });
    });
  });

  if (textOnly) return label || label === 'Loading' ? label.value : `#${name}#`;
  if (!label || label === 'Loading') return <span>{`#${name}#`}</span>;
  return <span style={{ alignItems: 'center' }}>{label.value}</span>;
});

export default EventLabel;

export const GetEventLabelValueFn = ({ name = '', groupName = '' }, eventLabels, environment, updateEventLabels) => {
  const { eventId, lang } = environment;
  const label = eventLabels[groupName.toUpperCase()] ? eventLabels[groupName.toUpperCase()][name.toUpperCase()] : null;
  if (typeof eventLabels[groupName.toUpperCase()] !== 'object' && eventLabels[groupName.toUpperCase()] !== 'Loading') {
    getGroup();
  } else if (label && label.languageCode != lang) {
    getGroup();
  }
  function getGroup() {
    runInAction(() => {
      eventLabels[groupName] = 'Loading';
    });
    Axios.get(`./eventLabel/getGroup/${eventId}?groupName=${groupName}&languageCode=${lang}`).then(({ data }) => {
      const groupData = {};
      data.map(d => {
        groupData[d.name.toUpperCase()] = d;
      });
      if (typeof updateEventLabels === 'function') {
        updateEventLabels(groupName.toUpperCase(), groupData);
      }
    });
  }
  return label && label !== 'Loading' ? label.value : `#${name}#`;
};
